import { IProviderSettings, SETTINGS } from '@spinnaker/core';

export interface IKubernetesProviderSettings extends IProviderSettings {
  defaults: {
    account?: string;
    namespace?: string;
    proxy?: string;
    internalDNSNameTemplate?: string;
    instanceLinkTemplate?: string;
    rrb?: boolean
    apiPrefix?: string;
  };
}

export const KubernetesProviderSettings: IKubernetesProviderSettings = <IKubernetesProviderSettings>SETTINGS.providers.kubernetes || { defaults: {} };
if (KubernetesProviderSettings) {
  KubernetesProviderSettings.resetToOriginal = SETTINGS.resetProvider('kubernetes');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/kubernetes.settings.ts